<div class="technical-difficulties" *ngIf="show">
  <div>
    <img
      [src]="this.imageUrlService.getImageUrl('/assets/images/error.svg')"
      alt="error sign"
    />
    <h2>{{ 'technical_difficulties_text' | i18next }}</h2>
    <p>{{ subText | i18next }}</p>
    <div class="btn-wrapper">
      <button (click)="handleButtonClick()">
        {{ btnText | i18next }}
      </button>
    </div>
  </div>
</div>
